<template>
  <section class="screen">


      <div class="tab">
          <div class="tab__type active"></div>
          <div class="tab__name">Timothy Wieg</div>
          <div class="tab__description">unread</div>
      </div>
    <div class="tab">
          <div class="tab__type inactive"></div>
          <div class="tab__name">Halvor Halerson</div>
          <div class="tab__description">read</div>
      </div>
    <div class="tab">
          <div class="tab__type inactive"></div>
          <div class="tab__name">Robert Kurtz</div>
          <div class="tab__description">read</div>
      </div>







  </section>

</template>
<script>
import { Carousel, Slide } from 'vue-carousel'
import { page } from 'vue-analytics'
import AOS from '../main'



export default {
  name: 'heroSection',
  data () {
    return {
    }
  },
  watch: {

  }
}
</script>

<style lang="scss" scoped>

  $break-small: 900px;
  $brandColor: #29aad0;
  $brandColorTwo: #70c8df;
  $accentColor: #de7c5e;

.screen {
    display: flex;
    flex-direction: column;
    position: relative;
    background-color: rgb(242, 248, 255);
    margin-top: 50px;
    padding: 20px 0 20px 0;
    width: 100%;
    align-items: center;
    height: auto;
    .tab {
        width: 90%;
        height: auto;
        padding: 20px 0;
        background-color: #fff;
        box-shadow: 1px 1px 2px rgb(195, 202, 211);
        border-radius: 5px;
        margin: 5px 0;
        display: flex;
        flex-direction: column;
        position: relative;
        align-items: center;
        justify-content: center;
        color: #777;
 

        &__type {
            background-color: $accentColor;
            width: 15px;
            height: 15px;
            border-radius: 50%;
            position: absolute;
            top: calc(50% - 7.5px);
            left: 20px;
        }
            // type color
            .active {
                background-color: $brandColor
            }
            .inactive {
                background-color: #ddd
            }
        &__name {
            width: 70%;
            text-align: left;
            font-weight: 600;
            font-size: 16px;
        }
        &__description{
            width: 70%;
            text-align: left;
            font-weight: 300;
            font-size: 14px;
            font-style: italic;
            padding: 2px 0;
        }
    }
    
}

  
</style>



// WEBPACK FOOTER //
// src/components/Inbox.vue